import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft, Facebook, Instagram } from "lucide-react";
import { Section } from "../components/UIBits";
import { useT } from "../lib/i18n";
import api from "../lib/api";

export default function NewsDetailPage() {
    const { t, lang } = useT();
    const { id } = useParams();
    const [n, setN] = useState(null);
    useEffect(() => { api.get(`/news/${id}`).then(r => setN(r.data)).catch(() => {}); }, [id]);
    if (!n) return <Section><div className="text-white/50">{t("common.loading")}</div></Section>;
    const url = typeof window !== "undefined" ? window.location.href : "";
    const ogImg = n.image_base64 || "";
    return (
        <div data-testid="news-detail">
            <Helmet>
                <title>{`${n.title} — Défi Ultime`}</title>
                <meta property="og:title" content={n.title} />
                <meta property="og:description" content={n.content.slice(0, 160)} />
                {ogImg && <meta property="og:image" content={ogImg} />}
                <meta property="og:url" content={url} />
                <meta property="og:type" content="article" />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>
            <Section>
                <Link to="/nouvelles" className="inline-flex items-center gap-2 text-[#4FE0D5] mb-6 hover:text-[#7FD93C]"><ArrowLeft size={16} /> {t("news.back_to_news")}</Link>
                <article className="max-w-3xl">
                    <div className="label-mini mb-3">{new Date(n.created_at).toLocaleDateString(lang === "en" ? "en-CA" : "fr-CA", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
                    <h1 className="font-display text-5xl uppercase tracking-tight mb-6">{n.title}</h1>
                    {n.image_base64 && <img src={n.image_base64} alt={n.title} className="w-full max-h-[480px] object-cover mb-8" style={{ objectPosition: `50% ${n.image_focal_y ?? 50}%` }} />}
                    <div className="text-white/80 leading-relaxed text-lg whitespace-pre-line">{n.content}</div>
                    {(n.facebook_url || n.instagram_url) && (
                        <div className="mt-10 flex gap-3">
                            {n.facebook_url && <a href={n.facebook_url} target="_blank" rel="noreferrer" className="btn-ghost flex items-center gap-2"><Facebook size={16} /> Facebook</a>}
                            {n.instagram_url && <a href={n.instagram_url} target="_blank" rel="noreferrer" className="btn-ghost flex items-center gap-2"><Instagram size={16} /> Instagram</a>}
                        </div>
                    )}
                </article>
            </Section>
        </div>
    );
}
